import styles from "@/styles/secondaryPage/frontpreunsub.module.scss"
import { Button, Form, Input } from "antd"
import DefaultLayout from "@/components/DefaultLayout"
import Head from "next/head"
import subscribeApi from '@/service/modules/myAccountApi'
import { useState } from "react";

export default function Frontpreunsub() {
  const onFinish = (fieldsValue: any) => {
    const url = `/newsletters/frontunsub?email=${encodeURIComponent(fieldsValue.email)}`
    window.location.href = url
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  type FieldType = {
    email?: string;
  };

  const [errorMessage, setErrorMessage] = useState("")
  const showError = (error: any) => {
    if(error.code) {
      setErrorMessage(error.message)
    } else {
      setErrorMessage("Please check your network connection and try again.")
    }
  }

  return (
    <>
      <Head>
        <title>Online Shopping New Zealand - Beauty &amp; Health, Computers, Toys, - Deals &amp; Discounts | BestDeals</title>
        <meta name="description" content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!" />
      </Head>
      <DefaultLayout >
        <div className={styles['frontpreunsub']}>
          <div className={styles['main']}>
            <div className={styles['title']}>Manage Email Preferences</div>
            <div className={styles['errorMessage']} dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
            <div className={styles['form']}>
              <Form
                name="basic"
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item<FieldType>
                  label="Please enter your Email Address:"
                  name="email"
                  rules={[
                    { required: true, message: 'Please input your email!' },
                    { type: 'email' },
                    () => ({
                      async validator(_, value) {
                        try {
                          if(!value){
                            setErrorMessage("")
                            return Promise.resolve()
                          }
                          const res: any = await subscribeApi.checkSubscribe({ email: value })
                          if (res.code === 100000) {
                            return Promise.resolve()
                          } else {
                            return Promise.reject();
                          }
                        } catch (error: any) {
                          showError(error)
                          return Promise.reject();
                        }
                      },
                      validateTrigger: "onBlur"
                    })
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 24 }}>
                  <Button type="primary" htmlType="submit" style={{ width: '100%', marginTop: '12px' }}>
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}